export default __webpack_public_path__ + "static/media/12.51646dbe.png";